



















































































































































































import Vue from 'vue';
import _ from 'lodash';

import { InformacaoParto } from '../../../../back/src/entity/InformacaoParto';
import { TipoInformacaoParto } from '../../../../back/src/types';

export default Vue.extend({
  name: 'InformacoesPartosTabela',
  props: {
    internacaoId: {
      type: null || Number,
      default: null,
    },
    informacoesPartos: {
      type: Array as () => InformacaoParto[],
      required: true,
    },
  },
  data: () => ({
    showAll: false,
    TipoInformacaoParto,
  }),
  computed: {
    headers() {
      const headers = [
        {
          value: 'datetime_informacao',
          text: 'Data',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          value: 'tipo_informacao_parto',
          text: 'Tipo',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          value: 'observacoes',
          text: 'Observações',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          value: 'responsavel.nome',
          text: 'Responsável',
          sortable: false,
          class: 'text-no-wrap',
        },
      ];
      if (this.showAll) {
        headers.push({
          value: 'internacao_id',
          text: 'Internação',
          sortable: false,
          class: 'text-no-wrap text-center',
        });
      }
      return headers;
    },
    informacoesPartosSorted() {
      return _.orderBy(
        _.filter(
          this.informacoesPartos as InformacaoParto[],
          item => (
            this.internacaoId && !this.showAll
              ? item.internacao_id === this.internacaoId && !item.datetime_cancelamento
              : !item.datetime_cancelamento
          ),
        ),
        ['datetime_informacao', 'id'],
        ['desc', 'desc'],
      );
    },
    countInformacoesPartosAnteriores() {
      if (!this.internacaoId) {
        return 0;
      }
      return _.get(_.countBy(
        this.informacoesPartos as InformacaoParto[],
        item => !item.datetime_cancelamento && item.internacao_id !== this.internacaoId,
      ), 'true', 0);
    },
  },
  methods: {
    stripedRow(index: number): string {
      if (Number(index) % 2 === 0) {
        return 'grey lighten-3';
      }
      return '';
    },
  },
});
